import React, { useState } from 'react';
import { Box, makeStyles } from '@material-ui/core';
import { i18n } from '../../../../../language';
import CreateCard from '../../../../DutyAssign/components/Template/create';
import { getArrayRandomKey } from '../../../../../utils';
import Card from '../../../../DutyAssign/components/Template/card';

const useStyles = makeStyles(() => ({
  title: {
    fontSize: '1.714rem',
    fontFamily: 'NotoSans-Medium',
    fontWeight: 700,
    marginBottom: '0.857rem',
  },
  subTitle: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '1.142rem',
    fontWeight: 500,
    color: '#7D86A9',
    marginBottom: '1.428rem',
  },
  templateBox: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: '1.25rem',
    minHeight: '15rem',
  },
}));

export default function TemplateList({ templateList, setEditTemplate, initTemplate }) {
  const classes = useStyles();
  const [isHover, setIsHover] = useState(null);
  const handleAddTemplate = () => {
    setEditTemplate(initTemplate);
  };
  const handleEdit = (template) => {
    setEditTemplate(template);
  };

  return (
    <div>
      {/* <Box className={classes.title}>{i18n.t('EHANDOVER_MY_TEMPLATE')}</Box>
      <Box className={classes.subTitle}>{i18n.t('EHANDOVER_VIEW_TEMPLATE')}</Box> */}
      <Box className={classes.templateBox}>
        {templateList.map((template, index) => {
          return (
            <Card
              id={template.id}
              flag={isHover}
              setFlag={setIsHover}
              title={template.templateName}
              index={index}
              Click={() => handleEdit(template)}
              key={getArrayRandomKey(index, `ehandover-note-template-${template.id}`)}
              showDefaultText={false}
              showFullName={true}
            />
          );
        })}
        <CreateCard
          Click={handleAddTemplate}
          id="ehandover-create-note-tem"
          text={i18n.t('DUTYASSIGN_MYTEMPLATE_BODY_CREATE')}
        />
      </Box>
    </div>
  );
}
